import { ReactElement, useMemo } from 'react';

import { PractitionerReceptionServiceSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { ReceptionServiceDuration } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { DurationText } from '../../../shared/components/DurationText';

type ReceptionServiceDurationCellProps = {
   readonly defaultEstimatedDuration: ReceptionServiceDuration;
   readonly practitioners: PractitionerReceptionServiceSimple[];
};

export const ReceptionServiceDurationCell = (props: ReceptionServiceDurationCellProps): ReactElement => {
   const [minDuration, maxDuration] = useMemo(() => {
      const allDurations = props.practitioners.map(
         (practitioner) => practitioner.estimatedDuration?.asMinutes() ?? props.defaultEstimatedDuration.asMinutes()
      );
      return [
         ReceptionServiceDuration.ofMinutes(Math.min(...allDurations)),
         ReceptionServiceDuration.ofMinutes(Math.max(...allDurations)),
      ];
   }, [props.practitioners, props.defaultEstimatedDuration]);

   return <DurationText testId={'duration'} min={minDuration} max={maxDuration} />;
};
